<div class="flex justify-content-center align-items-center h-full">
  <svg [attr.width]="width()" [attr.height]="height()" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.27504 3.27516L15.0584 15.0585M17.5 9.16683C17.5 13.7692 13.7691 17.5002 9.16671 17.5002C4.56433 17.5002 0.833374 13.7692 0.833374 9.16683C0.833374 4.56446 4.56433 0.833496 9.16671 0.833496C13.7691 0.833496 17.5 4.56446 17.5 9.16683Z" [attr.stroke]="stroke()" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</div>
